import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { NavigationExtras, Router } from "@angular/router";
import {
  JourneysReferences,
  MultifamilyRS,
  Segment,
  Solution,
} from "@core/models";
import { FlightLleegoService, StateService, UtilsService } from "@services";
import * as moment from "moment";
import { Subscription } from "rxjs";

@Component({
  selector: "app-flights-card-result",
  templateUrl: "./flights-card-result.component.html",
  styleUrls: ["./flights-card-result.component.scss"],
})
export class FlightsCardResultComponent implements OnInit, OnDestroy, OnChanges {
  @Input() userUuid: string;
  @Input() userFilters?: any;
  @Input() selectedPolicy: any;
  @Input() outwardList: JourneysReferences[];
  oneWay: any;
  @Input() travelersAge: number[];
  @Input() isUser: boolean;
  @Input() isEmployee: boolean;
  @Input() selectedUsers: any;
  @Input() projectData: any;
  @Input() company: any;
  selectedFlights: Array<Segment[]> = [];
  arrivalTime: string[] = [];
  airlineLogos: string[] = [];
  private subcriptions: Subscription[] = [];
  showContent = false;
  flightDuration: string[] = [];
  pageEvent: PageEvent;
  lowValue = 0;
  highValue = 10;
  multiFamilyRes: MultifamilyRS;
  selectedDurations: string[] = [];
  openedStopsIndex: Set<number> = new Set();
  totalFlightDuration: number = 0;

  constructor(
    private router: Router,
    public stateService: StateService,
    private flightLleegoService: FlightLleegoService,
    private utilsService: UtilsService
  ) {}

  ngOnInit() {
    this.oneWay = !this.stateService.flightSearchForm.get("roundtrip").value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedUsers) {
      this.selectedUsers = changes.selectedUsers.currentValue;
    }
    if (changes.projectData) {
      this.projectData = changes.projectData.currentValue;
    }
  }

  getDuration(segment: Segment) {
    const departureDate = moment(segment.object.departure_date);
    const arrivalDate = moment(segment.object.arrival_date);
    const duration = moment.duration(departureDate.diff(arrivalDate));
    return duration.toISOString().split("PT")[1];
  }

  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    this.openedStopsIndex.clear();
    return event;
  }

  getDetailsOrNextFlight(solution: Solution, checkedJourneyOutward, checkedJourneyReturn) {
    if (this.oneWay) {
      const segmentsIdArray = this.getAllSegmentRef(checkedJourneyOutward);
  
      this.selectedFlights.push(
        this.idArrayToSegmentArray(segmentsIdArray).map(segment => ({
          ...segment,
          airline: this.getAirlineInfo(segment.object.marketing_company)
        }))
      );
  
      this.goDetails(solution, checkedJourneyOutward, checkedJourneyReturn);
    } else {
      const segmentsIdArrayGoing = this.getAllSegmentRef(checkedJourneyOutward);
  
      this.selectedFlights[0] = this.idArrayToSegmentArray(segmentsIdArrayGoing).map(segment => ({
        ...segment,
        airline: this.getAirlineInfo(segment.object.marketing_company)
      }));
  
      const segmentsIdArrayReturn = this.getAllSegmentRef(checkedJourneyReturn);
  
      this.selectedFlights[1] = this.idArrayToSegmentArray(segmentsIdArrayReturn).map(segment => ({
        ...segment,
        airline: this.getAirlineInfo(segment.object.marketing_company)
      }));
  
      this.goDetails(solution, checkedJourneyOutward, checkedJourneyReturn);
    }
  }

  getAllSegmentRef(journeyId: string) {
    const segmentsRef: string[] = [];
    if (journeyId.includes("@")) {
      const segments = journeyId.split("@");
      segments.forEach((segment: string) => {
        segmentsRef.push(segment);
      });
    } else {
      segmentsRef.push(journeyId);
    }
    return segmentsRef;
  }

  goDetails(solution: Solution, checkedJourneyOutward, checkedJourneyReturn) {
    this.utilsService.loadingFlights = false;
    const associations = solution.data.associations;
    const totalTime: { outbound: string; return?: string } = {
      outbound: this.calcTotalSegmentTime(checkedJourneyOutward),
    };
    const arrivalDate: { outbound: string; return?: string } = {
      outbound: this.getLastSegment(checkedJourneyOutward).object.arrival_date,
    };

    if (!this.oneWay && associations.length > 1) {
      totalTime.return = this.calcTotalSegmentTime(checkedJourneyReturn);
      arrivalDate.return = this.getLastSegment(checkedJourneyReturn).object.arrival_date;
    }
    const lleegoToken = this.stateService.flightSelectedState.token;
    const navigationExtra: NavigationExtras = {
      state: {
        solutionId: solution.id,
        solutionIva: solution.iva,
        selectedFlights: this.selectedFlights,
        selectedUsers: this.selectedUsers,
        projectData: this.projectData,
        journeysAssociations: solution.data.associations,
        userUuid: this.userUuid,
        lleegoToken: lleegoToken,
        travelersAge:
          this.stateService.flightTravelers.length &&
          this.travelersAge.length < this.stateService.flightTravelers.length
            ? this.stateService.flightTravelers
            : this.travelersAge,
        isUser: this.isUser,
        multiFamilyRes: this.multiFamilyRes,
        duration: this.selectedDurations,
        isPriceWithinRange: this.isPriceWithinRange(solution.total_price.total, solution),
        authPriceOverDuration: this.needsAuthorization(solution, checkedJourneyOutward, checkedJourneyReturn),
        totalFlightDuration: this.totalFlightDuration,
        scalesInfo: this.getScalesInfo(solution, checkedJourneyOutward, checkedJourneyReturn),
        totalTime,
        arrivalDate,
        company: this.company,
        isEmployee: this.isEmployee,
        selectedPolicy: this.selectedPolicy,
        userFilters: this.userFilters,
      },
    };
    this.selectedFlights = [];
    this.utilsService.setBackNavigation(false);
    this.router.navigateByUrl("flight/order", navigationExtra);
  }

  formatDate(value) {
    return moment(value).format("DD/MM/YYYY");
  }

  getTime(value: string) {
    const res = value.split("T")[1].slice(0, 5);
    return res;
  }

  idArrayToSegmentArray(idArray: string[]) {
    const segments: Segment[] = [];
    idArray.forEach((segmentId: string) => {
      segments.push(this.getSegment(segmentId));
    });
    return segments;
  }

  getSegment(id: string): Segment {
    if (id.includes("@")) {
      const splittedIds = id.split("@");
      id = splittedIds[0];
    }
    const segmentFind: Segment =
      this.stateService.flightSelectedState.segments.find(
        (segment: Segment) => segment.id === id
      );
    return segmentFind;
  }

  getLastSegment(id: string): Segment {
    if (id.includes("@")) {
      const splittedIds = id.split("@");
      id = splittedIds[splittedIds.length - 1];
    }
    const segmentFind: Segment =
      this.stateService.flightSelectedState.segments.find(
        (segment: Segment) => segment.id === id
      );
    return segmentFind;
  }

  calcTotalSegmentTime(journeyId: string): string {
    const segmentArr = this.getSegments(journeyId);
    if (segmentArr.length === 0) {
      return this.getDuration(this.getSegment(journeyId));
    } else {
      let totalTime: string;
      const departDatetime = moment(
        segmentArr[0].object.departure_date,
        moment.ISO_8601
      );
      const returnDatetime = moment(
        segmentArr[segmentArr.length - 1].object.arrival_date,
        moment.ISO_8601
      );
      const duration = moment.duration(returnDatetime.diff(departDatetime));
      const days = duration.days();
      const hours = duration.hours();
      const hoursFormatted = `${hours}h `;
      const minutes = duration.minutes();
      const minutesFormatted = `${minutes}m`;
      totalTime = `${hoursFormatted}${minutesFormatted}`;
      if (days > 0) {
        const daysFormatted = `${days}d `;
        totalTime = `${daysFormatted}${totalTime}`;
      }
      return totalTime;
    }
  }

  getSegments(journeyId: string) {
    let stops = [];
    if (journeyId.includes("@")) {
      stops = [...journeyId.split("@")];
    }
    const stopSegments: Segment[] = [];
    stops.forEach((journey) => {
      stopSegments.push(this.getSegment(journey));
    });
    return stopSegments;
  }

  getStops(journeyId: string) {
    let stops = [];
    if (journeyId.includes("@")) {
      stops = [...journeyId.split("@")];
      if (stops.length > 1) {
        stops.splice(stops.length - 1, 1);
      }
    }
    const stopSegments: Segment[] = [];
    stops.forEach((journey) => {
      stopSegments.push(this.getSegment(journey));
    });
    const stopSegmentsNames = stopSegments.map(
      (segment) => segment.object.arrival
    );
    return stopSegmentsNames;
  }

  getLogo(value: string) {
    return `assets/img/airlines/small/${value}.png`;
  }

  getMultifamily(solution: Solution) {
    this.stateService.residentCandidates = solution.resident_candidates;
    this.utilsService.loadingFlights = true;
    const checkedJourneyOutward = solution.data.associations[0].journeyChecked ? solution.data.associations[0].journeyChecked : solution.data.associations[0].journey_references[0]
    let checkedJourneyReturn;
    const multifamilyReq = {
      token: this.stateService.flightSelectedState.token,
      travelID: solution.id,
      journey0: checkedJourneyOutward,
    };
    this.selectedDurations.push(
      this.calcTotalSegmentTime(checkedJourneyOutward)
    );
    if (solution.data.associations.length > 1) {
      checkedJourneyReturn = solution.data.associations[1].journeyChecked ? solution.data.associations[1].journeyChecked : solution.data.associations[1].journey_references[0]
      multifamilyReq["journey1"] = checkedJourneyReturn
      this.selectedDurations.push(
        this.calcTotalSegmentTime(checkedJourneyReturn)
      );
    }
    multifamilyReq["userUuid"] = this.userUuid;
    this.subcriptions.push(
      this.flightLleegoService.getMultifamily(multifamilyReq).subscribe(
        (res) => {
          this.multiFamilyRes = res;
          this.getDetailsOrNextFlight(solution, checkedJourneyOutward, checkedJourneyReturn);
        },
        (error) => {
          this.getDetailsOrNextFlight(solution, checkedJourneyOutward, checkedJourneyReturn);
        }
      )
    );
  }

  isPriceWithinRange(total: string, solution?): boolean {
    const totalPrice = parseFloat(total);
  
    if (
      !this.userFilters ||
      this.userFilters?.priceMinFlight == null ||
      this.userFilters?.priceMaxFlight == null
    ) {
      return true;
    }
  
    return (
      totalPrice >= this.userFilters.priceMinFlight &&
      totalPrice <= this.userFilters.priceMaxFlight
    );
  }

  private getAirlineInfo(iata: string): { name: string, iata: string } {
    const companyData = this.stateService.flightSelectedState?.data?.company;
    if (companyData && companyData[iata]) {
      return {
        name: companyData[iata].name,
        iata: iata
      };
    }
    return { name: "Unknown", iata };
  }

  toggleStops(index: number) {
    if (this.openedStopsIndex.has(index)) {
      this.openedStopsIndex.delete(index);
    } else {
      this.openedStopsIndex.add(index);
    }
  }

  getLayoverInfo(journeyId: string): Array<{
    from: string;
    to: string;
    arrivalTime: string;
    departureTime: string;
    duration: string;
    company: string;
    flightNumber: string;
  }> {
    const stopIds = journeyId.includes("@") ? journeyId.split("@") : [];
    const layovers: Array<{
      from: string;
      to: string;
      arrivalTime: string;
      departureTime: string;
      duration: string;
      company: string;
      flightNumber: string;
    }> = [];

    for (let i = 0; i < stopIds.length - 1; i++) {
      const currentSegment = this.getSegment(stopIds[i]);
      const nextSegment = this.getSegment(stopIds[i + 1]);

      const arrivalDate = moment(currentSegment.object.arrival_date);
      const departureDate = moment(nextSegment.object.departure_date);
      const duration = moment.duration(departureDate.diff(arrivalDate));
      const hours = duration.hours();
      const minutes = duration.minutes();

      layovers.push({
        from: currentSegment.object.arrival,
        to: nextSegment.object.arrival,
        arrivalTime: arrivalDate.format("HH:mm"),
        departureTime: departureDate.format("HH:mm"),
        duration: `${hours}h ${minutes}m`,
        company: nextSegment.object.marketing_company,
        flightNumber: `${nextSegment.object.marketing_company}${nextSegment.object.transport_number}`
      });
    }
    return layovers;
  }

  closeAllStopsPanels() {
    this.openedStopsIndex.clear();
  }

  getScalesInfo(solution: Solution, checkedJourneyOutward, checkedJourneyReturn): any[] {
    const associations = solution.data.associations;
    const result = [];

    associations.forEach((association, index) => {
      const journeyId = index === 0 ? checkedJourneyOutward : checkedJourneyReturn;
      const layovers = this.getLayoverInfo(journeyId).map((layover) => ({
        from: layover.from,
        to: layover.to,
        duration: layover.duration,
        flightNumber: layover.flightNumber,
        arrivalTime: layover.arrivalTime,
        departureTime: layover.departureTime,
        company: this.getAirlineInfo(layover.company).name
      }));
      result.push({
        type: this.oneWay ? 'outbound' : (index === 0 ? 'outbound' : 'return'),
        layovers
      });
    });
    return result;
  }

  needsAuthorization(solution: any, checkedJourneyOutward, checkedJourneyReturn): boolean {
    const price = parseFloat(solution?.total_price?.total ?? '0');

    const {
      priceMinFlight,
      priceMaxFlight,
      onlyFlightAuthorization,
      allowAmountOverDuration
    } = this.userFilters || {};

    if (onlyFlightAuthorization) return true;

    const withinMin = priceMinFlight == null ? true : price >= priceMinFlight;
    const withinMax = priceMaxFlight == null ? true : price <= priceMaxFlight;
    const withinBaseRange = withinMin && withinMax;

    const overDurCfg = allowAmountOverDuration;
    let anyLegDurationHours = 0;
    let anyLegExceeds = false;

    if (overDurCfg?.duration != null && overDurCfg?.amount != null) {
      const associations = solution?.data?.associations ?? [];
      const legHours: number[] = [];

      for (let index = 0; index < associations.length; index++) {
        let journeyId
        if (checkedJourneyOutward || checkedJourneyReturn) {
          journeyId = index === 0 ? checkedJourneyOutward : checkedJourneyReturn;
        } else {
          journeyId = associations[index].journeyChecked ? associations[index].journeyChecked : associations[index].journey_references[0];
        }
        const durationStr = this.calcTotalSegmentTime(journeyId);
        const hours = this.parseDurationToHours(durationStr);
        legHours.push(hours);
      }

      anyLegDurationHours = legHours.length ? Math.max(...legHours) : 0;
      anyLegExceeds = legHours.some(h => h >= overDurCfg.duration);
    }

    this.totalFlightDuration = anyLegDurationHours;
    if (!withinBaseRange) {
      if (anyLegExceeds && price <= Number(overDurCfg?.amount ?? NaN)) {
        return false;
      }
      return true;
    }

    return false;
  }

  parseDurationToHours(durationStr: string): number {
    const regex = /(?:(\d+)d)?\s*(?:(\d+)h)?\s*(?:(\d+)m)?/i;
    const match = regex.exec(durationStr);

    if (!match) return 0;

    const days = parseInt(match[1] || '0', 10);
    const hours = parseInt(match[2] || '0', 10);
    const minutes = parseInt(match[3] || '0', 10);

    return days * 24 + hours + minutes / 60;
  }

  private getFirstSegmentObject(association: any) {
    const segRef = association?.segment_references?.[0];
    return segRef?.object || null;
  }

  getCabinBaggageInfo(association: any) {
    const segObj = this.getFirstSegmentObject(association);
    const raw = segObj?.cabin_baggage;
    const known = raw !== undefined && raw !== null && typeof raw.included !== 'undefined';
    const included = !!raw?.included;
    return { known, included };
  }

  getCheckedBaggageInfo(association: any) {
    const segObj = this.getFirstSegmentObject(association);
    const b = segObj?.baggage;

    if (!b) {
      return { known: true, included: false, isUnits: false, topText: '', bottomText: '' };
    }

    const unitRaw = (b.unit ?? '').toString().trim().toLowerCase();
    const weightRaw = (b.weight ?? '').toString().trim();

    const q = Number(b.quantity);
    const hasQty = Number.isFinite(q) && q > 0;
    const hasWeight = !!weightRaw;

    let included = false;
    let isUnits = false;
    let topText = '';
    let bottomText = '';

    if (hasWeight) {
      included = true;
      bottomText = weightRaw;
    }

    if (hasQty) {
      if (unitRaw === 'units') {
        included = true;
        isUnits = true;
        topText = String(q);
      } else if (unitRaw === 'kilo') {
        included = true;
        if (!bottomText) bottomText = `${q} kg`;
      } else if (unitRaw === 'pounds') {
        included = true;
        if (!bottomText) bottomText = `${q} lb`;
      } else if (!unitRaw && !hasWeight) {
        included = true;
        bottomText = String(q);
      } else if (!['units','kilo','pounds'].includes(unitRaw)) {
        included = true;
        if (!bottomText) bottomText = String(q);
      }
    }

    if (!included) {
      return { known: true, included: false, isUnits: false, topText: '', bottomText: '' };
    }

    return { known: true, included, isUnits, topText, bottomText };
  }

  ngOnDestroy() {
    this.subcriptions.forEach((s) => s.unsubscribe());
  }

  getResultLength(): number {
    return this.stateService.flightSelectedState?.solutions?.length ?? 0;
  }

  checkAssociationJourney(association, journey: string) {
    association.journeyChecked = journey
  }

  isAssociationJourneyChecked(association, journey, w) {
    if (association.journeyChecked && association.journeyChecked === journey) {
      return true
    } else if (!association.journeyChecked && w === 0) {
      return true
    }
    return false
  }

  private getCheckedJourneyFromAssociation(association: any): string | null {
    if (!association) return null;
    return association.journeyChecked ?? association.journey_references?.[0] ?? null;
  }

  getCheckedJourneyOutward(solution: any): string | null {
    return this.getCheckedJourneyFromAssociation(solution?.data?.associations?.[0]);
  }

  getCheckedJourneyReturn(solution: any): string | null {
    return this.getCheckedJourneyFromAssociation(solution?.data?.associations?.[1]);
  }

}
